/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Container, Row, Col } from 'react-bootstrap';
import PageTitle from './layout/PageTitle';

export default function EditUser() {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState([]);

  const { id } = useParams();

  useEffect(() => {
    getUser();
  }, []);

  function getUser() {
    axios.get(`https://filenamebuilder.com/api/users.php/${id}`).then(function (response) {
      setInputs(response.data);
    });
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios.put(`https://filenamebuilder.com/api/users.php/${id}`, inputs).then(function (response) {
      navigate('/users');
    });
  };

  return (
    <>
      <PageTitle title="Edit User" />
      <Container>
        <Row>
          <Col>
            <form onSubmit={handleSubmit} className="row g-3 mb-6">
              <div className="mb-3">
                <label className="form-label" htmlFor="name">
                  Name{' '}
                </label>
                <input
                  className="form-control"
                  value={inputs.name}
                  type="text"
                  name="name"
                  id="name"
                  placeholder="First & Last"
                  onChange={(event) => handleChange(event)}
                />
              </div>
              <div className="mb-0">
                <label className="form-label" htmlFor="email">
                  Email{' '}
                </label>
                <input
                  className="form-control"
                  value={inputs.email}
                  type="text"
                  name="email"
                  id="email"
                  placeholder="email"
                  onChange={(event) => handleChange(event)}
                />
                <div id="emailHelp" className="form-text">
                  We&apos;ll never share your email with anyone else.
                </div>
              </div>
              <div className="mb-3">
                <Button type="submit">Save</Button>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </>
  );
}
